export default "__VITE_ASSET__BO_nGZ4m__"